<template>
  <div class="fixed-top" style="z-index:500;">
    <nav class="navbar navbar-light bg-light">
      <img class="pointer" style="width:200px" @click="$router.push({ name: 'Search' })" src="../assets/image/LAL/LAL_login_LOGO_B.svg" alt="">
      <div>
        <span class="mx-sm-2" v-if="auth.role === 'hr' || auth.role === 'admin'">
          <span @click="goPage('campus')" class="pointer">校園管理</span>
          |
        </span>
        <span class="mx-sm-2" v-if="auth.role !== 'user'">
          <span @click="goPage('teacher')" class="pointer">教師專區</span>
          |
        </span>
        <span class="mx-sm-2">
          <span v-if="!authorized" class="pointer">成為會員</span>
          <!-- <span @click="goPage('personal')" v-else class="pointer">個人專區</span> -->
          <span @click="goPage('personal')" v-else class="pointer">個人專區</span>
          |
        </span>
        <span class="mx-2">
          <span v-if="!authorized" class="pointer">登入</span>
          <span v-else @click="logout" class="pointer">登出</span>
        </span>
      </div>
    </nav>
    <nav class="navbar navbar-expand-lg navbar-light bg-light main py-0">
      <!-- <a class="navbar-brand pointer" style="font-size:1rem;" @click="$router.push({ name: 'Home'})">首頁</a> -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav" v-if="authorized">
          <li class="nav-item dropdown"  v-for="(item, index) in channels" :key="item.id">
            <a class="nav-link" role="button" data-toggle="dropdown" @mouseenter="selectedMain=null,main =index">
              {{item.name}}
            </a>
            <div :class="'main-menu'+index" class="dropdown-menu dropright main-menu m-0">
              <div class="main-menu-item " v-if="item.name === '多益口說專區'">
                <a class="dropdown-item topic-item pointer d-flex justify-content-between" @mouseenter="selectedMain=null" @click="goPage('raiders')">
                  <div class="menu-item">
                    多益口說攻略
                  </div>
                </a>
              </div>
              <div class="main-menu-item" v-if="item.name === '多益口說專區'">
                <a class="dropdown-item topic-item pointer d-flex justify-content-between" @mouseenter="selectedMain=null" @click="goPage('Toeic-Vocabularies')">
                  <div class="menu-item">
                    多益必考單字
                  </div>
                </a>
              </div>
              <div class="main-menu-item" v-for="(el, index) in item.child"  @mouseover="mouseHover(el,index)" :key="index">
                <a @click="goMenuPage(item, el)" class="dropdown-item pointer d-flex justify-content-between" :class="{'active': el.id === selectedMain}">
                  <div class="menu-item" >
                    {{el.name}}
                  </div>
                  <div v-if="el.items.length>0" class="pl-5 arrow">
                    <font-awesome-icon class="pointer chevron" size="lg" :icon="['fa', 'chevron-right']" />
                  </div>
                </a>
                <div>
                  <div class="dropdown-menu sub-menu m-0" v-if="el.items.length>0" :style="{'height':adjustment}">
                    <div class="nav-item" v-for="(item, index) in el.items" :key="index">
                      <a class="dropdown-item pointer" @click.self="goSubPage(item)" >
                        {{item.name}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown">
            <router-link :to="{ name: 'AI_Home' }" class="nav-link" role="button" data-toggle="dropdown">
              AI 小助教
            </router-link>
          </li>
          <!-- <li class="nav-item dropdown">
            <a class="nav-link" role="button" data-toggle="dropdown" @mouseenter="selectedMain=null">
              多益專區
            </a>
            <div class="dropdown-menu dropright main-menu m-0">
              <div class="main-menu-item" >
                <a class="dropdown-item topic-item pointer d-flex justify-content-between">
                  <div class="menu-item" @click="goPage('raiders')">
                    測驗簡介
                  </div>
                </a>
              </div>
              <div class="main-menu-item" >
                <a class="dropdown-item topic-item pointer d-flex justify-content-between">
                  <div class="menu-item" @click="goPage('vocabularies')">
                    必考單字
                  </div>
                </a>
              </div>
            </div>
          </li> -->
          <!-- <li  class="nav-item">
            <a class="nav-link" @click="goPage('library')" role="button">
              互動圖書館
            </a>
          </li> -->
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import api from '../store/api'
export default {
  name: 'Navbar',
  data () {
    return {
      // personalData: {},
      channels: [],
      // submenu: [],
      selectedMain: null,
      adjustment: '',
      main: ''
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'auth'
    ])
  },
  watch: {
  },
  mounted () {
    // this.getPersonalData()
    this.getUser()
    this.getChannels()
  },
  methods: {
    ...mapActions({
      getUser: 'getUser',
      dologout: 'logout'
    }),
    sendChannels() {
      this.$bus.$emit('channelsUpdated', this.channels);
    },
    goMenuPage (parent, el) {
      if (el && el.url === 'iMaker') {
        this.goStoryMarker()
        return
      }

      this.goPage(el.id)
    },
    goPage (id) {
      if (id === 'personal') {
        this.$router.push({ name: 'LeaderBoard'})
        // this.$router.push({ name: 'Record'})
      }
      else if (id === 'teacher') {
        this.$router.push({ name: 'Summary', params: { groupId: this.auth.groupId }})
      }
      else if (id === 'raiders') {
        this.$router.push({ name: 'Raiders'})
      }
      else if (id === 'campus') {
        this.$router.push({ name: 'GroupManagement', params: { groupId: this.auth.groupId }} )
      }
      else if (id === 'Toeic-Vocabularies') {
        this.$router.push({ name: 'Toeic-Vocabularies'})
      }
      else {
        this.autoNavbar()
        this.$router.push({ name: 'Channels', params: { channel: id } })
        // this.submenu = []
      }
    },
    goStoryMarker () {
      const token = this.auth && this.auth.user && this.auth.user.token
      const url = new URL('https://imaker.liveabc.com/ai_book')

      if (token) {
        url.searchParams.set('token', token)
      }

      window.location.href = url.toString()
    },
    autoNavbar () {
      if (document.body.clientWidth < 900) {
        const navBtn = document.querySelector('.navbar-toggler')
        console.log(navBtn)
        navBtn.click()
      }
    },
    navbarHover () {
      document.addEventListener("DOMContentLoaded", function(){
      if (window.innerWidth > 992) {
          document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem) {
            everyitem.addEventListener('mouseover', function(e){
              let el_link = this.querySelector('a[data-bs-toggle]')
              if(el_link != null){
                let nextEl = el_link.nextElementSibling
                el_link.classList.add('show')
                nextEl.classList.add('show')
              }
            })
            everyitem.addEventListener('mouseleave', function (e) {
              let el_link = this.querySelector('a[data-bs-toggle]')
              if (el_link != null) {
                let nextEl = el_link.nextElementSibling
                el_link.classList.remove('show')
                nextEl.classList.remove('show')
              }
            })
          })
        }
      })
    },
    goSubPage (el) {
      console.log(el)
      if (el.type === 'internal_link') {
        if (el.parent_name_en === 'TOEIC Speaking') {
          this.$router.push({ name: 'Topic-Exam', params: { channel: el.id, id: el.url } })
        } else {
          this.$router.push({ name: 'Topic-Exam-Bridge', params: { channel: el.id, id: el.url } })
        }
      } else {
        this.$router.push({ name: 'Course', params: { channel: el.id } })
      }
    },
    async getChannels () {
      const { data } = await api.get('/contents/channels')
      this.channels = data.data
    },
    // async getSubChannel (id) {
    //   const { data } = await api.get(`/contents/channels/${id}`, { headers: {'showLoading': false }} )
    //   this.submenu = data.data.items
    // },
    async logout () {
      await this.dologout()
      this.$router.push({ name: 'Login' })
    },
    mouseHover (el,index) {
      this.selectedMain = el.id
      if (index+1 > el.items.length) {
        this.adjustment = document.querySelector(`.main-menu${this.main}`).offsetHeight + 'px'
      } else {
        this.adjustment = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/color.scss";
  .main {
    min-height: 45px;
    background-color: $main-color !important;
  }
  .navbar {
    a{
      font-size: 1.2rem;
      color: $white-color !important;
    }
    z-index: 0;
    }
  .dropdown-menu {
    background-color: $light-gray;
    // text-align: center;
    text-align: left;
    .main-title {
      line-height: 3rem;
      font-weight: bolder;
      border-bottom: black 1px solid;
    }
    a {
      color: #000 !important;
      .arrow {
        display: none;
      }
    }
    // .dropdown-item:hover,:active {
    //   background-color: $sub-color !important;
    //   color: #ffff !important;
    // }
    .active {
      color: #ffff !important;
      background-color: $sub-color !important;
    }
  }
  .sub-menu {
    // min-height: 50vh;
    max-height: 80vh;
    overflow: auto;
    background-color: $light-gray!important;
    .dropdown-item:hover,:active {
      background-color: $gray-color !important;
      color: #ffff !important;
    }
  }
  .topic-item:hover {
    color: #ffff !important;
    background-color: $sub-color !important;
  }
  @media all and (min-width: 992px) {
    .navbar .nav-item .dropdown-menu{ display: none; }
    .navbar .nav-item:hover .main-menu{ display: block; }
    .navbar .main-menu .main-menu-item:hover .sub-menu{ display: block; }
    .arrow {
      display: block !important;
    }
  }
  @media all and (max-width: 992px) {
    .menu-item {
      margin: auto;
    }
  }
</style>
